import { CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { useConnection } from 'hooks/useConnection'
import { useTokenBalancesWithLoadingIndicator } from 'lib/hooks/useCurrencyBalance'
import { useMemo } from 'react'

import { REFETCH_POLICY_FAST } from '../../config/RefetchPolicies'
import { useAllTokens } from '../../hooks/Tokens'

export {
  default as useCurrencyBalance,
  useCurrencyBalances,
  useTokenBalance,
  useTokenBalances,
  useTokenBalancesWithLoadingIndicator,
} from 'lib/hooks/useCurrencyBalance'

// mimics useAllBalances
// TODO: cache tokens with non-zero balances and update those faster
// Maybe do the "main" tokens fast, the rest (e.g. legacy) slow
export function useAllTokenBalancesFast(): [{ [tokenAddress: string]: CurrencyAmount<Token> | undefined }, boolean] {
  const { account } = useConnection()
  const allTokens = useAllTokens()
  const allTokensArray = useMemo(() => Object.values(allTokens ?? {}), [allTokens])
  const [balances, balancesIsLoading] = useTokenBalancesWithLoadingIndicator(
    account ?? undefined,
    allTokensArray,
    REFETCH_POLICY_FAST
  )

  return [balances ?? {}, balancesIsLoading]
}
